import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";

async function getBartrackLines({ bartrackId }) {
  try {
    const linesCol = collection(db, "Bartracks", bartrackId, "Lines");
    const linesSnapshot = await getDocs(linesCol);

    const lines = linesSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

    return lines;
  } catch (error) {
    console.error("Erreur lors de la récupération des lignes :", error);
    return [];
  }
}

export default getBartrackLines;
